import { inject } from 'vue';

export default function useCreditCardFields() {
    const {
        legacyStripeElementsEnabled = false,
        legacyStripeElementsUrl = '',
        stripeElementsUrl = legacyStripeElementsUrl,
        onStripeProcessedAnalytics = () => {},
    } = inject('creditCardFieldsContext', {});

    return {
        legacyStripeElementsEnabled,
        stripeElementsUrl,
        onStripeProcessedAnalytics,
    };
}
